module.exports = __webpack_public_path__ + "img/75721.c6e01061.svg";